import { useEffect } from 'react'

import {
  ManualAttachmentFileType,
  useGetAttachmentInformationByEntityQuery,
} from '~/api/graphql/generated/types'

export const useImagingAttachments = (orderId: string | undefined) => {
  const { data, loading, error, refetch } =
    useGetAttachmentInformationByEntityQuery({
      variables: {
        entityId: orderId || '',
        entityType: ManualAttachmentFileType.IdexxImaging,
      },
      skip: !orderId,
    })

  // We do want to refetch to ensure that when switching orders, we get the latest attachments
  useEffect(() => {
    if (orderId) {
      refetch()
    }
  }, [orderId, refetch])

  const attachments = data?.attachmentInformationByEntity?.attachments || []

  return {
    attachments,
    loading,
    error,
    refetch,
  }
}
